import React, {useState, useEffect} from 'react';
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import logo from '../Assets/logo/skilletix.png'
import SuccessModal from "../components/shared/SuccessModal";

const SignupCompany = () => {

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        mobile: "",
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const [mobileError, setMobileError] = useState("");
    const [emailError, setEmailError] = useState("");
    const navigate = useNavigate();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
         if (name === "mobile") {
            const mobilePattern = /^[6789]\d{9}$/;
            if (!mobilePattern.test(value)) {
                setMobileError("Please enter a valid mobile number"); 
            } else {
                setMobileError("");
            }
         }
         if (name === "email") {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setEmailError("Please enter a valid email address.");
            } else {
                setEmailError("");
            }
        }
        setFormData({ ...formData, [name]: value });
    };
    const handleCloseModal = () => {
        setShowSuccessModal(false);
        navigate("/login");
      };

      useEffect(() => {
          if (errorMessage) {
            const timer = setTimeout(() => {
              setErrorMessage(null);
            }, 3000); // Hide after 2 seconds
      
            return () => clearTimeout(timer); // Cleanup on unmount
          }
        }, [errorMessage]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!/^[6789]\d{9}$/.test(formData.mobile)) {
            setMobileError("Please enter a valid mobile number.");
            return;
          }
          if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            setEmailError("Please enter a valid email address.");
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setErrorMessage("Password Not Match Please Enter Same Password!");
            return;
        }
        setLoading(true);


        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}users/add-employer`, {
                name: formData.name,
                email: formData.email,
                password: formData.password,
                mobile: formData.mobile,
            });
            setLoading(false);

            if (response.status === 201) {
                setShowSuccessModal(true);
                setFormData({
                  name: "",
                  email: "",
                  password: "",
                  confirmPassword: "",
                  mobile: "",
                });
              } else {
                setErrorMessage(`Error: ${response.data.message}`);
              }
            } catch (error) {
            //   setErrorMessage("An error occurred during registration.");
              setErrorMessage ("Error in registering. Please try again.");
              setLoading(false);

              if (
                error.response.status === 400) {
               setErrorMessage ("Both Email and Mobile are already registered.");
             }
             else if(
               error.response.status === 401){
                 setErrorMessage("Email already exists. Please use a different email");
               }
               else if(
                 error.response.status === 402){
                   setErrorMessage("Mobile already registered. Please use a different number")
                 }
 
            }
    };

    return (
        <div className="login-area py-120">
            <div className="container">
                <div className="col-md-8 col-lg-7 col-xl-5 mx-auto">
                    <div className="login-form">
                        <div className="login-header">
                            <img
                            loading="lazy"
                            role="presentation"
                            decoding="async"
                            fetchpriority="high" src={logo} alt="" />
                            <p>Create Employer account</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Company Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder="Your Name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Company Email Address</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="Your Email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                                {emailError && <small className="text-danger">{emailError}</small>}
                            </div>
                            <div className="form-group">
                                <label>Mobile</label>
                                <input
                                    type="text"
                                    name="mobile"
                                    className="form-control"
                                    placeholder="Your Mobile"
                                    value={formData.mobile}
                                    onChange={handleInputChange}
                                    required
                                />
                                {mobileError && <small className="text-danger">{mobileError}</small>}
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <div className="position-relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        className="form-control"
                                        placeholder="Your Password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <i
                                        className={`fas position-absolute top-50 translate-middle-y end-0 me-3 ${
                                            showPassword ? "fa-eye-slash" : "fa-eye"
                                        }`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowPassword(!showPassword)}
                                        ></i>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Confirm Password</label>
                                <div className="position-relative">
                                    <input
                                        type={showConfPassword ? "text" : "password"}
                                        name="confirmPassword"
                                        className="form-control"
                                        placeholder="Confirm Password"
                                        value={formData.confirmPassword}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <i
                                    className={`fas position-absolute top-50 translate-middle-y end-0 me-3 ${
                                        showConfPassword ? "fa-eye-slash" : "fa-eye"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowConfPassword(!showConfPassword)}
                                    ></i>
                                </div>
                            </div>
                            
                            <div className="form-check form-group">
                                <input className="form-check-input" type="checkbox" id="agree" required/>
                                <label className="form-check-label" htmlFor="agree">
                                    I agree with the <a href="#">Terms Of Service.</a>
                                </label>
                            </div>
                            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                            <div className="d-flex align-items-center">
                            <button type="submit" className="theme-btn" disabled={loading}>
                  {loading ? "Signing Up..." : <><i className="far fa-paper-plane"></i> Sign Up</>}
                </button>
                            </div>
                        </form>
                        <SuccessModal
              show={showSuccessModal}
              onClose={handleCloseModal}
              success={true}
              message="Your registration is successful. Our team is reviewing your details and will reach out to you soon"
            />
                        <div className="login-footer">
                            {/* <div className="login-divider">
                                <span>Or</span>
                            </div>
                            <div className="social-login">
                                <a href="#" className="btn-fb">
                                    <i className="fab fa-facebook"></i> Login With Facebook
                                </a>
                                <a href="#" className="btn-gl">
                                    <i className="fab fa-google"></i> Login With Google
                                </a>
                            </div> */}
                            <p>
                                Already have an account? <Link to={"/login"}>Sign In.</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignupCompany;
